import { EBusinessAppoinmentStatus, TBusinessAppoinmentMappers } from './types';

export const mappers: TBusinessAppoinmentMappers = {
  200: state => ({
    businessAppointments: state,
    status: EBusinessAppoinmentStatus.Success,
  }),
  400: ({ message }) => ({
    businessAppointments: null,
    message,
    status: EBusinessAppoinmentStatus.Error,
  }),
};
